import { SET_RUNNINGS_JOBS } from "../actions/actionTypes";
export default function (state = { editingTranslations: false, runningJobs: [] }, action) {
  switch (action.type) {
    case "EDIT_TRANSLATIONS":
      return Object.assign({}, state, {
        editingTranslations: action.edit,
      });
    case "SET_RUNNING_JOBS":
      return Object.assign({}, state, {
        runningJobs: action.runningJobs,
      });
    default:
      return state;
  }
}
